(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCT(root) {
    var tabBtns = root.querySelectorAll('[data-ct-tab]');
    var tables  = root.querySelectorAll('[data-ct-table]');
    if (!tabBtns.length) return;

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-ct-tab');
        tabBtns.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('ct__tab-btn--active', active);
          b.setAttribute('aria-selected', String(active));
        });
        tables.forEach(function (t) {
          t.hidden = t.getAttribute('data-ct-table') !== target;
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ct').forEach(function (el) { initCT(el); });
  });
  document.addEventListener('shopify:section:load', function (e) {
    var ct = e.target.querySelector('.ct');
    if (ct) initCT(ct);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-split"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSF(wrapper) {
    wrapper.querySelectorAll('.sf-item__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.sf-item');
        var isOpen = item.classList.contains('sf-item--open');
        item.classList.toggle('sf-item--open', !isOpen);
        trigger.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  function init() {
    document.querySelectorAll('.sf__faq').forEach(function (el) {
      initSF(el.closest('.sf__card') || el);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.sf__faq')) initSF(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFaqTabs(root) {
    var tabs  = Array.prototype.slice.call(root.querySelectorAll('[data-faqt-tab]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faqt-group]'));

    function closeItem(item) {
      var answer  = item.querySelector('.faqt-item__answer');
      var trigger = item.querySelector('.faqt-item__trigger');
      if (!answer) return;
      answer.style.maxHeight = '0';
      item.classList.remove('faqt-item--open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function openItem(item) {
      var answer  = item.querySelector('.faqt-item__answer');
      var trigger = item.querySelector('.faqt-item__trigger');
      if (!answer) return;
      answer.style.maxHeight = answer.scrollHeight + 'px';
      item.classList.add('faqt-item--open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function switchTab(value) {
      tabs.forEach(function (t) {
        var active = t.dataset.faqtTab === value;
        t.classList.toggle('faqt__tab--active', active);
        t.setAttribute('aria-selected', String(active));
      });
      items.forEach(function (item) {
        var match = item.dataset.faqtGroup === value;
        item.hidden = !match;
        if (!match) closeItem(item);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { switchTab(tab.dataset.faqtTab); });
    });

    items.forEach(function (item) {
      var trigger = item.querySelector('.faqt-item__trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        if (item.classList.contains('faqt-item--open')) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });

    if (tabs.length > 0) {
      switchTab(tabs[0].dataset.faqtTab);
    } else {
      items.forEach(function (item) { item.hidden = false; });
    }
  }

  function init() {
    document.querySelectorAll('.faqt').forEach(initFaqTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var faqt = e.target.querySelector('.faqt');
      if (faqt) initFaqTabs(faqt);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFC(section) {
    var tabs    = Array.from(section.querySelectorAll('[data-fc-tab]'));
    var panels  = Array.from(section.querySelectorAll('[data-fc-panel]'));
    var prevBtns = Array.from(section.querySelectorAll('[data-fc-prev]'));
    var nextBtns = Array.from(section.querySelectorAll('[data-fc-next]'));

    function activeTrack() {
      var p = section.querySelector('.fc__panel--active');
      return p ? p.querySelector('[data-fc-track]') : null;
    }

    function scrollAmount() {
      var track = activeTrack();
      if (!track) return 0;
      var card = track.querySelector('.fc-card');
      if (!card) return 0;
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      return card.offsetWidth + gap;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.dataset.fcTab;
        tabs.forEach(function (t) {
          t.classList.remove('fc__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) { p.classList.remove('fc__panel--active'); });
        tab.classList.add('fc__tab--active');
        tab.setAttribute('aria-selected', 'true');
        var target = section.querySelector('[data-fc-panel="' + idx + '"]');
        if (target) target.classList.add('fc__panel--active');
      });
    });

    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t = activeTrack();
        if (t) t.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    });

    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t = activeTrack();
        if (t) t.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    });
  }

  function init() {
    document.querySelectorAll('.fc').forEach(function (el) {
      var section = el.closest('[id^="shopify-section-"]');
      if (section) initFC(section);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.fc')) initFC(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-center"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initLazyVideos() {
    var videos = document.querySelectorAll('.hc__bg-video[data-src]');
    if (!videos.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var video = entry.target;
        video.src = video.dataset.src;
        video.load();
        video.play().catch(function () {});
        observer.unobserve(video);
      });
    }, { rootMargin: '300px' });
    videos.forEach(function (v) { observer.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyVideos);
  } else {
    initLazyVideos();
  }

  function toEmbedUrl(url) {
    var yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_\-]+)/);
    if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0';
    var vm = url.match(/vimeo\.com\/(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
    return null;
  }

  function openModal(modal, videoUrl) {
    var body = modal.querySelector('.hc-modal__body');
    if (videoUrl && body) {
      var embed = toEmbedUrl(videoUrl);
      if (embed) {
        body.innerHTML =
          '<div class="hc-modal__video-wrap"><iframe src="' + embed +
          '" allow="autoplay; fullscreen; encrypted-media" allowfullscreen></iframe></div>';
      }
    }
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    var body = modal.querySelector('.hc-modal__body');
    if (body) body.innerHTML = '';
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-hc-modal]');
    if (trigger) {
      var modal = document.getElementById(trigger.dataset.hcModal);
      if (modal) openModal(modal, trigger.dataset.hcVideo);
      return;
    }
    if (e.target.classList.contains('hc-modal__backdrop')) {
      var modal = e.target.closest('.hc-modal');
      if (modal) closeModal(modal);
      return;
    }
    var closeBtn = e.target.closest('.hc-modal__close');
    if (closeBtn) {
      var modal = closeBtn.closest('.hc-modal');
      if (modal) closeModal(modal);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.hc-modal[aria-hidden="false"]').forEach(closeModal);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-left"] && !Shopify.designMode) return;
  try {
    
(function () {
  function toEmbedUrl(url) {
    var yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_\-]+)/);
    if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0';
    var vm = url.match(/vimeo\.com\/(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
    return null;
  }

  function openModal(modal, videoUrl) {
    var body = modal.querySelector('.hl-modal__body');
    if (videoUrl && body) {
      var embed = toEmbedUrl(videoUrl);
      if (embed) {
        body.innerHTML =
          '<div class="hl-modal__video-wrap"><iframe src="' + embed +
          '" allow="autoplay; fullscreen; encrypted-media" allowfullscreen></iframe></div>';
      }
    }
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    var body = modal.querySelector('.hl-modal__body');
    if (body) body.innerHTML = '';
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-hl-modal]');
    if (trigger) {
      var modal = document.getElementById(trigger.dataset.hlModal);
      if (modal) openModal(modal, trigger.dataset.hlVideo);
      return;
    }
    if (e.target.classList.contains('hl-modal__backdrop')) {
      var modal = e.target.closest('.hl-modal');
      if (modal) closeModal(modal);
      return;
    }
    var closeBtn = e.target.closest('.hl-modal__close');
    if (closeBtn) {
      var modal = closeBtn.closest('.hl-modal');
      if (modal) closeModal(modal);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.hl-modal[aria-hidden="false"]').forEach(closeModal);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards-center"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initICC(wrapper) {
    var track = wrapper.querySelector('[data-icc-track]');
    if (!track) return;

    function cardWidth() {
      var card = track.querySelector('.icc-card');
      if (!card) return 0;
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      return card.offsetWidth + gap;
    }

    wrapper.querySelector('[data-icc-prev]').addEventListener('click', function () {
      track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
    });

    wrapper.querySelector('[data-icc-next]').addEventListener('click', function () {
      track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
    });
  }

  function init() {
    document.querySelectorAll('.icc').forEach(initICC);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) {
    var icc = e.target.querySelector('.icc');
    if (icc) initICC(icc);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initIC(wrapper) {
    var track = wrapper.querySelector('[data-ic-track]');
    if (!track) return;

    function cardWidth() {
      var card = track.querySelector('.ic-card');
      if (!card) return 0;
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      return card.offsetWidth + gap;
    }

    wrapper.querySelector('[data-ic-prev]').addEventListener('click', function () {
      track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
    });

    wrapper.querySelector('[data-ic-next]').addEventListener('click', function () {
      track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
    });
  }

  function init() {
    document.querySelectorAll('.ic').forEach(initIC);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) {
    var ic = e.target.querySelector('.ic');
    if (ic) initIC(ic);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle-cards"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* ── Comparison / info modal ─────────────────────────────── */
  document.addEventListener('click', function (e) {
    var cmpTrigger = e.target.closest('[data-lc-cmp-modal]');
    if (cmpTrigger) {
      var modal   = document.getElementById(cmpTrigger.getAttribute('data-lc-cmp-modal'));
      var tmpl    = document.getElementById(cmpTrigger.getAttribute('data-lc-cmp-tmpl'));
      if (!modal || !tmpl) return;
      var body = document.getElementById(modal.id.replace('lc-info-modal', 'lc-info-body'));
      if (body) {
        body.innerHTML = '';
        body.appendChild(tmpl.content.cloneNode(true));
        var accent = tmpl.getAttribute('data-accent');
        if (accent) body.closest('.lc-info-modal__card').style.setProperty('--lc-cmp-accent', accent);
      }
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      return;
    }

    if (e.target.closest('[data-lc-info-close]')) {
      var modal = e.target.closest('.lc-info-modal');
      if (modal) {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      }
      return;
    }

    /* ── Video modal ─────────────────────────────────────── */
    var vidTrigger = e.target.closest('[data-lc-vid-modal]');
    if (vidTrigger) {
      var modal = document.getElementById(vidTrigger.getAttribute('data-lc-vid-modal'));
      if (!modal) return;
      var url = vidTrigger.getAttribute('data-lc-vid-url');
      var body = modal.querySelector('.lc-video-modal__body');
      if (url && body) {
        var yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_\-]+)/);
        var vm = url.match(/vimeo\.com\/(\d+)/);
        var embed = yt ? 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0'
                  : vm ? 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1' : null;
        if (embed) {
          body.innerHTML = '<div class="lc-video-modal__video-wrap"><iframe src="' + embed +
            '" allow="autoplay; fullscreen; encrypted-media" allowfullscreen></iframe></div>';
        }
      }
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      return;
    }

    if (e.target.classList.contains('lc-video-modal__backdrop')) {
      var modal = e.target.closest('.lc-video-modal');
      if (modal) { modal.setAttribute('aria-hidden','true'); document.body.style.overflow = ''; var b = modal.querySelector('.lc-video-modal__body'); if (b) b.innerHTML = ''; }
      return;
    }

    var closeVid = e.target.closest('.lc-video-modal__close');
    if (closeVid) {
      var modal = closeVid.closest('.lc-video-modal');
      if (modal) { modal.setAttribute('aria-hidden','true'); document.body.style.overflow = ''; var b = modal.querySelector('.lc-video-modal__body'); if (b) b.innerHTML = ''; }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.lc-info-modal.is-open').forEach(function (m) {
      m.classList.remove('is-open'); document.body.style.overflow = '';
    });
    document.querySelectorAll('.lc-video-modal[aria-hidden="false"]').forEach(function (m) {
      m.setAttribute('aria-hidden','true'); document.body.style.overflow = '';
      var b = m.querySelector('.lc-video-modal__body'); if (b) b.innerHTML = '';
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSpt(section) {
    var tabs   = Array.prototype.slice.call(section.querySelectorAll('[data-spt-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-spt-panel]'));

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-spt-tab');
        tabs.forEach(function (t) {
          var active = t.getAttribute('data-spt-tab') === target;
          t.classList.toggle('spt__tab--active', active);
          t.setAttribute('aria-selected', String(active));
        });
        panels.forEach(function (p) {
          p.classList.toggle('spt__panel--active', p.getAttribute('data-spt-panel') === target);
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('.spt').forEach(initSpt);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.spt');
      if (el) initSpt(el);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-highlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

  function animateStat(el) {
    var target   = parseInt(el.getAttribute('data-sh-count'), 10) || 0;
    var suffix   = el.getAttribute('data-sh-suffix') || '';
    var prefix   = el.getAttribute('data-sh-prefix') || '';
    var duration = 2800;
    var start    = null;

    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var value    = Math.round(easeOutCubic(progress) * target);
      el.textContent = prefix + value + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.querySelectorAll('[data-sh-count]').forEach(animateStat);
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.25 });

  function init() {
    document.querySelectorAll('[data-sh-stats]').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-stats"] && !Shopify.designMode) return;
  try {
    
(function () {
  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

  function animateStat(el) {
    var raw      = el.getAttribute('data-txs-count') || '0';
    var target   = parseFloat(raw) || 0;
    var decimals = (raw.split('.')[1] || '').length;
    var suffix   = el.getAttribute('data-txs-suffix') || '';
    var prefix   = el.getAttribute('data-txs-prefix') || '';
    var duration = 2800;
    var start    = null;

    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var value    = easeOutCubic(progress) * target;
      el.textContent = prefix + (decimals > 0 ? value.toFixed(decimals) : Math.round(value)) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.querySelectorAll('[data-txs-count]').forEach(animateStat);
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.25 });

  function init() {
    document.querySelectorAll('[data-txs-stats]').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
